import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_5 = { style: {"position":"relative","height":"calc(90vh - 420px)","min-height":"250px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Scatter = _resolveComponent("Scatter")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.location)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.location.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_v_select, {
        label: _ctx.$t('message.propertyX'),
        density: "compact",
        variant: "outlined",
        items: _ctx.filteredProperties,
        "hide-details": "",
        "item-value": "id",
        "item-title": "title",
        "return-object": "",
        modelValue: _ctx.locationProperty1,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.locationProperty1) = $event))
      }, {
        selection: _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.raw.sectionTitle) + " - " + _toDisplayString(_ctx.removeMdiBracketToIcon(item.raw.title)), 1)
        ]),
        item: _withCtx(({ item, props }) => [
          _createVNode(_component_v_list_item, _mergeProps(props, {
            title: item.raw.sectionTitle + ' - ' + _ctx.removeMdiBracketToIcon(item.raw.title)
          }), null, 16, ["title"])
        ]),
        _: 1
      }, 8, ["label", "items", "modelValue"])
    ]),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_component_v_select, {
        label: _ctx.$t('message.propertyY'),
        density: "compact",
        variant: "outlined",
        items: _ctx.filteredProperties,
        "hide-details": "",
        "item-value": "id",
        "item-title": "title",
        "return-object": "",
        modelValue: _ctx.locationProperty2,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.locationProperty2) = $event))
      }, {
        selection: _withCtx(({ item }) => [
          _createElementVNode("div", null, _toDisplayString(item.raw.sectionTitle) + " - " + _toDisplayString(_ctx.removeMdiBracketToIcon(item.raw.title)), 1)
        ]),
        item: _withCtx(({ item, props }) => [
          _createVNode(_component_v_list_item, _mergeProps(props, {
            title: item.raw.sectionTitle + ' - ' + _ctx.removeMdiBracketToIcon(item.raw.title)
          }), null, 16, ["title"])
        ]),
        _: 1
      }, 8, ["label", "items", "modelValue"])
    ]),
    (_ctx.model != null && _ctx.model.locationGroups != null && _ctx.model.locationGroups.length > 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createVNode(_component_v_select, {
            label: _ctx.$tc('message.locationGroupsType' + _ctx.model.locationGroupsType + 'Name'),
            density: "compact",
            variant: "outlined",
            clearable: "",
            items: _ctx.model.locationGroups,
            "hide-details": "",
            "item-value": "id",
            "item-title": "name",
            modelValue: _ctx.locationGroupId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.locationGroupId) = $event))
          }, null, 8, ["label", "items", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Scatter, {
        options: _ctx.chartOptions,
        data: _ctx.chartData
      }, null, 8, ["options", "data"])
    ])
  ]))
}